import { assertNever } from '@eversports/utility-types'

import {
  RequiredInformationInitialValues,
  RequiredInformationInput,
  RequiredInformationType,
} from '../../../typings/AdditionalInformation'

/**
 * Generate initial values for the passed fields according to the passed types
 */
function getInitialValues(
  requiredInformationInput: RequiredInformationInput,
  requiredInformationTypes: Array<RequiredInformationType>,
) {
  const initialValues: RequiredInformationInitialValues = {}

  for (const requiredInformationType of requiredInformationTypes) {
    switch (requiredInformationType) {
      case RequiredInformationType.REQUIRED_INFORMATION_TYPE_ADDRESS:
        const { street, zip, city, country, detail } = { ...requiredInformationInput.address }
        initialValues.street = street || ''
        initialValues.detail = detail || ''
        initialValues.zip = zip || ''
        initialValues.city = city || ''
        initialValues.country = country || ''
        break
      case RequiredInformationType.REQUIRED_INFORMATION_TYPE_BIRTHDAY:
        const birthday = requiredInformationInput.birthday
        initialValues.birthday = birthday || ''
        break
      case RequiredInformationType.REQUIRED_INFORMATION_TYPE_PHONE_NUMBER:
        const phoneNumber = requiredInformationInput.phoneNumber
        initialValues.phoneNumber = phoneNumber || ''
        break
      case RequiredInformationType.REQUIRED_INFORMATION_TYPE_FISCAL_CODE:
        const fiscalCode = requiredInformationInput.fiscalCode
        initialValues.fiscalCode = fiscalCode || ''
        break
      default:
        assertNever(requiredInformationType)
    }
  }

  return initialValues
}

export default getInitialValues
